export const reportToLrs = async ({ verbId, objectId, objectName = null, duration = null }) => {
  try {
    const response = await fetch(`${window.config.baseApiUrl}/api/lrs/report`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      keepalive: true,
      body: JSON.stringify({
        verbId: String(verbId),
        objectId,
        objectName,
        duration,
      }),
    });

    if (!response.ok) {
      console.error(`Failed to report LRS action (${verbId}): ${response.statusText}`);
    }
  } catch (error) {
    console.error(`Error reporting LRS action (${verbId}):`, error);
  }
};
